import { Component, OnInit } from '@angular/core';
import { CouponService } from '../../services/coupon.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-import-coupon',
  templateUrl: './import-coupon.component.html',
  styleUrls: ['./import-coupon.component.scss']
})
export class ImportCouponComponent implements OnInit {
  isSlide: boolean = false;
  fileToUpload: File = null;
  data: any[];

  constructor(private _couponService: CouponService, private router: Router) { }

  ngOnInit() {
  }

  sideBarToggle() {
    if (this.isSlide) {
        this.isSlide = false;
    }
    else {
        this.isSlide = true;
    }
}
handleFileInput(files: FileList) {
  this.fileToUpload = files.item(0);
}
uploadFileToActivity() {
  if (this.fileToUpload) {
    if (this.fileToUpload.type == "text/csv") {
      var loginUser = JSON.parse(localStorage.getItem("currentUser"));
      var form_data = new FormData();
      form_data.append("token", loginUser.token);
      form_data.append("files", this.fileToUpload);
      //form_data.append("partnerid", loginUser.userDetail.partnerId);
      this._couponService.fileUploadService(form_data).subscribe(
        (data) => {
          if (data["returnCode"] === 0) {
 
            alert("File successfully imported...");
          }
          // do something, if upload success
          //location.reload();
          this.router.navigate(['/coupon']);
        },
        (error) => {
          console.log(error);
          alert(error.error.returnMsg);
        }
      )




      // this._couponService.fileUploadService(form_data).subscribe(
      //   (data) => {
      //     if (data["returnCode"] === 0) {
      //       //this.file.nativeElement.value = null
      //       alert("File successfully imported...");
      //       //this.getPartnerPatient();
      //     }
      //     // do something, if upload success
      //     location.reload();
      //   },
      //   (error) => {
      //     console.log(error);
      //     alert(error.error.returnMsg);
      //   }
      // )

      // var loginUser = JSON.parse(localStorage.getItem("currentUser"));
      // var form_data = new FormData();
      // form_data.append("token", loginUser.token);
      // form_data.append("file", this.fileToUpload);
      // form_data.append("partnerid", loginUser.userDetail.partnerId);
      // this.partnerService.fileUploadService(form_data).subscribe(
      //   (data) => {
      //     if (data["returnCode"] === 0) {
      //       //this.file.nativeElement.value = null

      //       alert("File successfully imported...");
      //       this.getPartnerPatient();
      //     }
      //     // do something, if upload success
      //     location.reload();
      //   },
      //   (error) => {
      //     console.log(error);
      //     alert(error.error.returnMsg);
      //   }
      // );


    }
    else{
      alert("Not a csv file")
    }
  }
}

}




// WEBPACK FOOTER //
// ./src/app/admin/import-coupon/import-coupon.component.ts